import React     from 'react';
import PropTypes from 'prop-types';

export default class LocaleString extends React.Component {
    static propTypes = {
        code: PropTypes.string.isRequired,
        getString: PropTypes.func.isRequired,
        replaceOptions: PropTypes.object,
        className: PropTypes.string
    };

    render() {
        const {
            code,
            getString,
            replaceOptions,
            className
        } = this.props;

        return (
            <span
                data-key={ code }
                dangerouslySetInnerHTML={ { __html: getString( code, replaceOptions ) } }
                className={ className } />
        );
    }
}
